import { generateClassName } from '@klv/shared/utils/functions';
import MixedMedia from '../mixed-media';

import * as s from './styles/mixedMedias.module.css';

import type { IMixedMedias } from './types';
import type { TBaseProps } from '@klv/shared/types';

const MixedMedias = ({ mixedMediaData, currentIndex, ...props }: IMixedMedias & TBaseProps<'div'>) => (
  <div className={s.mixedMedias} {...props}>
    {mixedMediaData.map((media, index) => (
      <div
        className={generateClassName([s.mediaWrapper, currentIndex === index && s.show])}
        key={index}
        aria-hidden={currentIndex !== index}
      >
        <MixedMedia mixedMedia={media} />
      </div>
    ))}
  </div>
);

export default MixedMedias;
